import styles from "./asset/menuBar.module.scss";
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

const MenuBar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about-us' },
    { label: 'Pricing', path: '/pricing' },
  ];

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <nav className={styles.menuBar} ref={menuRef}>
      <div className={styles.leftSection}>
        <button
          className={styles.logoButton}
          onClick={() => handleNavigate('/')}
          aria-label="Go to homepage"
        >
          <img
            className={styles.logo}
            alt="Prepal Logo"
            src={require("../../publicAsset/media/Prepal Logo 3.svg").default}
          />
        </button>

        {/* Desktop nav links */}
        <ul className={styles.navLinks}>
          {navItems.map((item, index) => (
            <li key={item.label} className={styles.navItem}>
              <button
                className={styles.navLink}
                onClick={() => handleNavigate(item.path)}
              >
                {item.label}
              </button>
              {index < navItems.length - 1 && (
                <span className={styles.divider} aria-hidden="true" />
              )}
            </li>
          ))}
        </ul>
      </div>

      {/* Desktop buttons */}
      <div className={styles.rightSection}>
        <button
          className={styles.signInButton}
          onClick={() => handleNavigate('/sign-in')}
        >
          Sign In
        </button>

        <button
          className={styles.ctaButton}
          onClick={() => handleNavigate('/sign-up')}
        >
          <svg
            className={styles.icon}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M7.5 15L12.5 10L7.5 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Start Now</span>
        </button>
      </div>

      {/* Mobile actions: icon buttons + hamburger */}
      <div className={styles.mobileActions}>
        <button
          className={styles.mobileSignInBtn}
          onClick={() => handleNavigate('/sign-in')}
          aria-label="Sign In"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10Z" stroke="#1e0ea4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 18C3 15.2386 6.13401 13 10 13C13.866 13 17 15.2386 17 18" stroke="#1e0ea4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        <button
          className={styles.mobileCtaBtn}
          onClick={() => handleNavigate('/sign-up')}
          aria-label="Start Now"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        <button
          className={styles.hamburgerBtn}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? (
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 5L17 17M17 5L5 17" stroke="#1e0ea4" strokeWidth="2" strokeLinecap="round" />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 6H19M3 11H19M3 16H19" stroke="#1e0ea4" strokeWidth="2" strokeLinecap="round" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className={styles.mobileMenuDropdown}>
          {navItems.map((item) => (
            <button
              key={item.label}
              className={styles.mobileNavLink}
              onClick={() => handleNavigate(item.path)}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default MenuBar;
